import { createRoot, hydrateRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { dismissBootSplashWhenReady } from './lib/bootSplash'
import { devLoginRedirectUrl } from './lib/devAutoLogin'
import { shouldDiscardPrerenderedDocument } from './lib/hostGuard'
import { loadRouteModules } from './lib/routeComponents'
import { startApp } from './lib/startApp'
import { createRoutes } from './routes'

startApp()

const root = document.getElementById('root')!

async function renderApp() {
  // The server says which site this is, as it does when it chooses whether to send a prerendered page.
  const routes = createRoutes(window.__CAI_CONFIG__?.marketingSite ?? false)
  // A page that fails to load stays lazy, so the router retries it and shows the route's error page.
  await loadRouteModules(routes, window.location.pathname).catch(() => {})
  const app = <RouterProvider router={createBrowserRouter(routes)} />
  if (root.firstChild && !shouldDiscardPrerenderedDocument(root, window.location.hostname)) {
    hydrateRoot(root, app)
  } else {
    createRoot(root).render(app)
  }
}

// Compiled out of production bundles: import.meta.env.DEV is a static false there.
const devLogin = import.meta.env.DEV ? devLoginRedirectUrl(window.location.href) : null

if (devLogin) {
  window.location.replace(devLogin)
} else {
  dismissBootSplashWhenReady()
  void renderApp()
}
